<template>
  <div v-if="reactions && reactions.length" class="reaction-container">
    <div
      v-for="reaction of reactionsGrouped"
      :key="reaction.icon"
      class="reaction-icon"
    >
      {{ reaction.icon }}
      <span v-if="reaction.quantity > 1" class="reaction-quantity">{{
        reaction.quantity
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    reactions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    reactionsGrouped() {
      if (!this.reactions?.length) {
        return []
      }
      return this.reactions.reduce((acc, current) => {
        const reaction = acc.find(reaction => reaction.icon === current.icon)
        if (reaction) {
          reaction.quantity++
        } else {
          acc.push({
            icon: current.icon,
            quantity: 1
          })
        }

        return acc
      }, [])
    }
  }
}
</script>
<style lang="scss" scoped>
.reaction-container {
  background: var(--gl-color-shades-white);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: 100px;
  padding: var(--gl-spacing-01);
  padding-bottom: 2px;
  gap: var(--gl-spacing-01);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;

  .reaction-icon {
    font-size: var(--gl-font-size-xxs);
  }
  .reaction-quantity {
    color: var(--gl-color-shades-gray-100);
    font-weight: var(--gl-font-weight-light);
    font-size: var(--gl-font-size-xxs);
    line-height: var(--gl-line-height-xxxs);
  }
}
</style>
